import { render, staticRenderFns } from "./waiting_reverse.vue?vue&type=template&id=f1264398&scoped=true"
import script from "./waiting_reverse.vue?vue&type=script&lang=js"
export * from "./waiting_reverse.vue?vue&type=script&lang=js"
import style0 from "./waiting_reverse.vue?vue&type=style&index=0&id=f1264398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1264398",
  null
  
)

export default component.exports